import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReminderService } from '@org/shared-services';
import { Router } from '@angular/router';

@Component({
    selector: 'lib-reminder-overlay',
    imports: [CommonModule],
    templateUrl: './reminderOverlay.component.html',
    styleUrl: './reminderOverlay.component.scss'
})
export class ReminderOverlayComponent {
  showOverlay = false;

  constructor(private reminderService: ReminderService, private router: Router) {}

  ngOnInit(): void {
    this.reminderService.overlayVisible$.subscribe(visible => {
      this.showOverlay = visible;
    });
  }

  closeOverlay(): void {
    this.reminderService.hideOverlay();
  }

  navigateToMorningMeeting(): void {
    this.reminderService.hideOverlay();
    this.router.navigate(['/morning-meeting']);
  }
}
